<script lang="ts" setup>
	import type { TableRowSelection } from 'ant-design-vue/lib/table/interface'
	import type { GadgetPendingPolicyResponse } from '~/types'

	const props = defineProps<{
		records: GadgetPendingPolicyResponse['pendingPolicies']
		recordColumn?: TableColumn
		rowSelection?: TableRowSelection<unknown>
		actionBtnText?: string
		status?: string
		isLoading?: boolean
	}>()

	const { currencyToNaira } = useCurrency()
	const custodianRecord = computed(() => props.records.map((item, i) => ({ ...item, ...item.meta, key: i })))
	const {
		policiesTableColumn: { gadget }
	} = useProducts()
	const emits = defineEmits<{
		(event: 'change', param: RecordSchema): void
	}>()

	const getStaff = (arg: RecordSchema) => {
		emits('change', arg)
	}
</script>

<template>
	<div>
		<shared-table-loader v-slot="{ columns }" :loading="isLoading" :columns="recordColumn || gadget">
			<a-table :row-selection="rowSelection" :columns="columns" :data-source="custodianRecord">
				<template #bodyCell="{ column, record, index }">
					<span v-if="column.dataIndex === 'sn'">{{ index + 1 }}</span>
					<span v-if="column.dataIndex === 'model'">
						{{ record?.gadget_model || record?.gadget_model?.name || 'N/A' }}
					</span>
					<span v-if="column.dataIndex === 'brand'">
						{{ record?.gadget_brand?.name || record?.gadget_brand || 'N/A' }}
					</span>
					<span v-if="column.dataIndex === 'gadget_type'">
						{{ record?.meta?.gadget_type?.name || record?.meta?.gadget_type || 'N/A' }}
					</span>
					<span v-if="column.dataIndex === 'custodian'">
						{{ record?.first_name || record?.meta?.first_name }}
						{{ record?.last_name || record?.meta?.last_name }}
					</span>

					<span v-if="column.dataIndex === 'value'">
						{{ currencyToNaira(record?.gadget_value || 0) }}
					</span>

					<my-cover-plan-status
						v-if="column.key === 'status'"
						:pending="!record?.policy_number"
						:plan-details="record || null"
					/>

					<button
						v-if="column.dataIndex === 'details'"
						type="button"
						aria-label="activate staff"
						aria-roledescription="view beneficiary plan details"
						class="text-sm font-medium"
						@click="getStaff(record)"
					>
						<span class="font-medium text-primary-2"> {{ actionBtnText || 'Activate' }} </span>
					</button>
				</template>
			</a-table>
		</shared-table-loader>
	</div>
</template>
